module.exports = __webpack_public_path__ + "img/sub-nav-links-kia.bb7694a1.png";